/** Background colors */
export const hoverBg100 = `hover:bg-gray-100 hover:dark:bg-gray-800`; // #f3f4f6 dark: #1f2937

export const bgBase = `bg-white dark:bg-gray-900`; // #ffffff dark: #111827
export const bg100 = `bg-gray-100 dark:bg-gray-800`; // #f3f4f6 dark: #1f2937
export const bg200 = `bg-gray-200 dark:bg-gray-700`; // #e5e7eb dark: #374151
export const bg300 = `bg-gray-300 dark:bg-gray-600`; // #d1d5db dark: #4b5563
export const bg350 = `bg-gray-350`; // #c4c4c4 dark: #4b5563
export const bg400 = `bg-gray-400 dark:bg-gray-500`; // #9ca3af dark: #6b7280
export const bg20 = `bg-gray-20 dark:bg-gray-400`; // #ebebeb dark: #9ca3af

export const bgSlate100 = `bg-slate-100 dark:bg-slate-800`; // #f1f5f9 dark: #1e293b
export const bgSlate200 = `bg-slate-200 dark:bg-slate-700`; // #e2e8f0 dark: #334155
export const bgSlate300 = `bg-slate-300 dark:bg-slate-600`; // #cbd5e1 dark: #475569
export const bgSlate400 = `bg-slate-400 dark:bg-slate-500`; // #94a3b8 dark: #64748b
export const bgSlate500 = `bg-slate-500 dark:bg-slate-400`; // #64748b dark: #94a3b8
export const bgSlate600 = `bg-slate-600 dark:bg-slate-300`; // #475569 dark: #cbd5e1
export const bgSlate700 = `bg-slate-700 dark:bg-slate-200`; // #334155 dark: #e2e8f0
export const bgSlate800 = `bg-slate-800 dark:bg-slate-100`; // #1e293b dark: #f1f5f9
export const bgSlate900 = `bg-slate-900 dark:bg-white`; // #0f172a dark: #ffffff

export const bgPrimary = `bg-blue-600 dark:bg-blue-400`; // #2563eb dark: #60a5fa
export const bgPrimaryLight = `bg-blue-200 dark:bg-blue-300`; // #bfdbfe dark: #93c5fd
export const bgPrimaryLightest = `bg-blue-100 dark:bg-blue-200`; // #dbeafe dark: #bfdbfe
export const bgPrimaryText = `bg-blue-700 dark:bg-blue-100`; // #1d4ed8 dark: #dbeafe
export const bgLightestBlue = `bg-light-blue-500 dark:bg-light-blue-500`; // #F4F9FF
export const bgLightBlue = `bg-blue-50`;

export const bgNegative = `bg-red-600 dark:bg-red-300`; // #dc2626 dark: #fca5a5
export const bgNegativeLight = `bg-red-200 dark:bg-red-200`; // #fecaca dark: #fecaca
export const bgNegativeLightest = `bg-negativeLightest-light dark:bg-negativeLightest-dark`; // #fee2e2 dark: #fee2e2

export const bgWarning = `bg-warning-light dark:bg-warning-dark`; // #f97316 dark: #fdba74
export const bgWarningLight = `bg-warningLight-light dark:bg-warningLight-dark`; // #fed7aa dark: #fed7aa

export const bgPositive = `bg-positive-light dark:bg-positive-dark`; // #16a34a dark: #86efac
export const bgPositiveLight = `bg-positiveLight-light dark:bg-positiveLight-dark`; // #bbf7d0 dark: #bbf7d0
export const bgPositiveDark = `bg-positiveDark-light dark:bg-positiveDark-dark`; // #15803d dark: #15803d

export const bgBlue = `bg-blue-600 dark:bg-blue-400`; // #2563eb dark: #60a5fap
export const bgDarkestBlue = `bg-darkest-blue-500 dark:bg-darkest-blue-500`; // #00315D
export const bgYellow = `bg-yellow-400 dark:bg-yellow-200`; // #facc15 dark: #fef08a
export const bgTeal = `bg-teal-600 dark:bg-teal-400`; // #0d9488 dark: #2dd4bf
export const bgCyan = `bg-cyan-700 dark:bg-cyan-300`; // #0E7490 dark: #67E8F9
export const bgOlive = `bg-olive-600 dark:bg-olive-300`; // #6b7280 dark: #d1d5db
export const bgGreen = `bg-green-600 dark:bg-green-400`; // #16a34a dark: #4ade80
export const bgGreenLightest = `bg-[#efffef]`; // #efffef
export const bgOrange = `bg-orange-600 dark:bg-orange-300`; // #ea580c dark: #fdba74
export const bgRed = `bg-red-500 dark:bg-red-300`; // #ef4444 dark: #fca5a5
export const bgPink = `bg-pink-600 dark:bg-pink-300`; // #db2777 dark: #f9a8d4
export const bgLavender = `bg-lavender-600 dark:bg-lavender-400`; // #c084fc dark: #d8b4fe
export const bgPurple = `bg-purple-500 dark:bg-purple-300`; // #a855f7 dark: #d8b4fe
export const bgEmerald = `bg-emerald-700 dark:bg-emerald-400`; // #047857 dark: #34d399

export const bgBlueLight = `bg-blue-600/[.25] dark:bg-blue-600/[.25]`; // #2563eb/[.25] dark: #2563eb/[.25]
export const bgYellowLight = `bg-yellow-400/[.25] dark:bg-yellow-400/[.25]`; // #facc15/[.25] dark: #facc15/[.25]
export const bgTealLight = `bg-teal-600/[.25] dark:bg-teal-600/[.25]`; // #0d9488/[.25] dark: #0d9488/[.25]
export const bgOliveLight = `bg-olive-600/[.25] dark:bg-olive-600/[.25]`; // #6b7280/[.25] dark: #6b7280/[.25]
export const bgGreenLight = `bg-green-600/[.25] dark:bg-green-600/[.25]`; // #16a34a/[.25] dark: #16a34a/[.25]
export const bgOrangeLight = `bg-orange-600/[.25] dark:bg-orange-600/[.25]`; // #ea580c/[.25] dark: #ea580c/[.25]
export const bgRedLight = `bg-red-500/[.25] dark:bg-red-500/[.25]`; // #ef4444/[.25] dark: #ef4444/[.25]
export const bgPinkLight = `bg-pink-600/[.25] dark:bg-pink-600/[.25]`; // #db2777/[.25] dark: #db2777/[.25]
export const bgLavenderLight = `bg-lavender-600/[.25] dark:bg-lavender-600/[.25]`; // #c084fc/[.25] dark: #c084fc/[.25]
export const bgPurpleLight = `bg-purple-500/[.25] dark:bg-purple-500/[.25]`; // #a855f7/[.25] dark: #a855f7/[.25]
export const bgBagLightBlue = `bg-bag-light-blue-500 dark:bg-bag-light-blue-500`; // #FAFDFF

// Social brand colors — fixed by the platforms, so they have no design-system
// equivalent and are intentionally expressed as literal hex values.
export const bgFacebook = `bg-[#3b5998] hover:bg-[#2d4373]`; // #3b5998 hover: #2d4373
export const bgTwitter = `bg-[#1dcaff] hover:bg-[#00b2e9]`; // #1dcaff hover: #00b2e9

export const bgBtnRed = `bg-btnRed hover:bg-red-700 active:bg-red-700`; // #d53939 hover: #d53939/[.25] active: #b91c1c
export const bgBtnGreen = `bg-btnGreen hover:bg-btnGreen/[.25] active:bg-green-700`; // #31aa31 hover: #31aa31/[.25] active: #15803d

// Plan header background colors
export const bgPlanFlexible = 'bg-wp-action-blue'; // Plans/Deal page "Most Flexible" plan
export const bgPlanPopular = 'bg-wp-vital-orange'; // Plans/Deal page "Most Popular" plan
export const bgPlanValue = 'bg-wp-green'; // Plans/Deal page "Best Value" plan

export const bg5 = 'bg-black'; // #000000
export const bg4 = 'bg-neutral-700'; // #404040
export const bg3 = 'bg-neutral-500'; // #737373
export const bg2 = 'bg-neutral-300'; // #d4d4d4
export const bg1 = 'bg-zinc-100'; // #f4f4f5
export const bg0 = 'bg-white'; // #ffffff

// Hex → Token mapping (migrated in recent audit)
// This block documents hexes encountered in the schedule/calendar components
// and maps them to the project's design tokens or exports raw hex constants
// for cases where a raw color value is required (SVGs, inline styles).
// Mappings applied:
// #0069CC -> token: `textBlue` (see text.ts) — exported here as `hexBlue0069CC`
// #9334E9 -> token: `bgLavender`/`textLavender` — exported here as `hexLavender9334E9`
// #16A34A -> token: `bgGreen`/`textGreen` — exported here as `hexGreen16A34A`
// #FF8200 -> token: `bgOrange`/`textOrange` — exported here as `hexOrangeFF8200`
// #F6F6F6 -> approximate token: `bg100` — exported here as `hexF6F6F6`
// #F4F9FF -> token: `bgLightestBlue` — exported here as `hexF4F9FF`
// #DEDEDE -> approximate token: `bg2` — exported here as `hexDEDEDE`
// #D0D0D0 -> approximate token: `border-neutral-300` — exported here as `hexD0D0D0`
// #898989 -> recommended ring replacement: `focus:ring-neutral-700` — exported here as `hex898989`
// #E9E9EA -> hover replacement: `hover:bg-gray-100` — exported here as `hexE9E9EA`
// #D5D1EF/#9E5BEF -> schedule palette colors; exported here as `hexD5D1EF` / `hex9E5BEF`

// (Removed detailed mapping block per scope guidance.)
// Existing tokens already include hex comments next to their definitions above.
// If a raw hex string is required in a component (SVG/stroke/etc), prefer
// using a literal there or an existing token — avoid adding new hex exports.
